import React from 'react';
import { getImage } from './image.service.ts';
import RotatingLine from './rotatingLine/rotatingLine.tsx';
import { TextStyle } from '@ticketmaster/global-design-system';
import { Trans, withTranslation } from 'react-i18next';

import styles from './image.module.scss';
import { T } from '@/v2/helpers/i18n';

type Props = {
  barcodeType: string;
  barcodeValue: string;
  isSecureEntry: boolean;
} & T;

const BarcodeImage = ({ barcodeValue, isSecureEntry, barcodeType, t }: Props) => {
  const barcodeImage = getImage({ barcodeValue, isSecureEntry, barcodeType });
  const isBarcode = barcodeType.toLowerCase() === 'qrcode' || barcodeType.toLowerCase() === 'barcode';

  const renderNoBarcodeMessage = () => {
    if (barcodeImage) {
      return;
    }

    return (
      <TextStyle.Etna>
        <Trans>{'WALLET.TICKETS.NO_BARCODE'}</Trans>
      </TextStyle.Etna>
    );
  };

  return (
    <div>
      <div className={`${styles.imageContainer} ${!isSecureEntry && isBarcode ? styles.qrCode : null}`}>
        {isSecureEntry && !!barcodeImage && <RotatingLine />}
        {renderNoBarcodeMessage()}
        {!!barcodeImage && <img className={styles.barcodeImage} src={`${barcodeImage}`} alt={barcodeValue} />}
      </div>
      {isSecureEntry && !!barcodeImage && (
        <TextStyle.Snowdon size={'uno'}>{t('WALLET.TICKETS.SCREENSHOTS_ARE_NOT_VALID')}</TextStyle.Snowdon>
      )}
    </div>
  );
};

export default withTranslation('translation')(BarcodeImage);
